export default "__VITE_ASSET__CST53sR3__"